import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isEqual } from 'lodash-es'; // Or write a deep compare utility

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService implements OnDestroy {
  
  private subjects: Record<string, BehaviorSubject<any>> = {};

  ngOnDestroy(): void {
    // Clean up subjects when service is destroyed (app shutdown)
    Object.values(this.subjects).forEach(subject => subject.complete());
  }

  get<T>(key: string): T | null {
    const json = sessionStorage.getItem(key);
    try {
      return json ? JSON.parse(json) as T : null;
    } catch (error) {
      console.error(`Failed to parse sessionStorage item for key "${key}":`, error);
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    try {
      const existingValue = this.get<T>(key);
      if (isEqual(existingValue, value)) {
        return; // Avoid redundant writes and emissions
      }
  
      sessionStorage.setItem(key, JSON.stringify(value));
      this.getOrCreateSubject<T>(key).next(value);
    } catch (error) {
      console.error(`Failed to set sessionStorage item for key "${key}":`, error);
    }
  }

  //set<T>(key: string, value: T): void {
  //  try {
  //    sessionStorage.setItem(key, JSON.stringify(value));
  //    this.getOrCreateSubject<T>(key).next(value);
  //  } catch (error) {
  //    console.error(`Failed to set sessionStorage item for key "${key}":`, error);
  //  }
  //}

  remove(key: string): void {
    try {
      sessionStorage.removeItem(key);
      this.getOrCreateSubject(key).next(null);
    } catch (error) {
      console.error(`Failed to remove sessionStorage item for key "${key}":`, error);
    }
  }

  /** Reactive session state stream */
  watch<T>(key: string): BehaviorSubject<T | null> {
    return this.getOrCreateSubject<T>(key);
  }

  /** Check if a key exists in session storage */
  has(key: string): boolean {
    return sessionStorage.getItem(key) !== null;
  }

  /** Clear all session storage and notify all subjects */
  clear(): void {
    try {
      sessionStorage.clear();
      // Notify all subjects that their values are now null
      Object.values(this.subjects).forEach(subject => subject.next(null));
    } catch (error) {
      console.error('Failed to clear sessionStorage:', error);
    }
  }

  private getOrCreateSubject<T>(key: string): BehaviorSubject<T | null> {
    if (!this.subjects[key]) {
      const initialValue = this.get<T>(key);
      this.subjects[key] = new BehaviorSubject<T | null>(initialValue);
    }
    return this.subjects[key] as BehaviorSubject<T | null>;
  }
}